import reqVenda from "../../../../services/reqMultiTenant/reqVenda";
import FilterReportDateItens from "./reportDateItens/filter";
import MainReportMatrix from "../../matrix";
import functions from "../../../../util/functions";

function InactiveClients() {
	const options = {
		title: "Clientes Inativos",
		subtitle: "Relação de clientes com ausência de compras",
		ident: "clientesInativos",
		identFilter: "filterClientesInativos",
		identReport: "reportClientesInativos",
		tableColumns: [
			{ key: "id_cliente", label: "ID", align: "center" },
			{ key: "tipo_cliente", label: "Tipo Cliente", align: "left" },
			{ key: "nome", label: "Cliente", align: "left" },
			{ key: "data_ultima_compra", label: "Última Compra", align: "center" },
			{ key: "dias_inativo", label: "Dias Inativo", align: "center" },
		],
		reportColumns: [
			{ key: "id_cliente", label: "ID", align: "center" },
			{ key: "tipo_cliente", label: "Tipo Cliente", align: "left" },
			{ key: "nome", label: "Cliente", align: "left" },
			{ key: "data_ultima_compra", label: "Última Compra", align: "center" },
			{ key: "dias_inativo", label: "Dias Inativo", align: "center" },
		],
		showTime: false,
		hasActive: false,
		hasSaleType: false,
		hasClientType: true,
		hasSituacaoCompra: true,
		hasDate: false,
		parametersDate: [{ id: 1, label: "Período da venda", value: "dtVenda" }],
		hasParam: true,
		parametersFilter: [{ id: 1, label: "Maior ou igual a X dias", value: "dias" }],
	};

	const fetch = async (filterData, newPage, perPage = 15) => {
		const newFilterData = { ...filterData, page: newPage, perPage };

		const response = await reqVenda.listInactiveClients(newFilterData);

		if (response?.data) {
			response.data = response.data.map((item) => ({
				...item,
				data_ultima_compra: item.data_ultima_compra
					? functions.dateTimeToStrIso8601(item.data_ultima_compra)
					: "Nunca comprou",
				dias_inativo: item.dias_inativo ?? "-",
			}));
		}

		return response;
	};

	return (
		<div className="flex flex-col mt-14 min-h-[calc(100vh-6.5rem)]">
			<MainReportMatrix options={options} fetch={fetch} FormFilter={FilterReportDateItens} />
		</div>
	);
}

export default InactiveClients;
